import React from "react";
import { AddressWithNameInnerForm } from "../../../components/ValidatedFields/AddressWithNameInnerForm";
import { NameAndAddress, PostalAndVisitingAddress } from "shared/utils/fieldsHelper/companyFields";

interface Props {
  value: PostalAndVisitingAddress;
  onChange: (addresses: PostalAndVisitingAddress) => void;
  submit: () => void;
  isSaving: boolean;

  noLeftPadding?: boolean;
}



export const VisitingAddressForm = (props: Props) => {
  const visitingAndPostalAddressSame = Object.keys(props.value.postalAddress).map(key => {
    return props.value.postalAddress[key] === props.value.visitingAddress[key];
  }).every(value => value);

  const onChange = (newVisitingAddress: NameAndAddress) => {
    if (visitingAndPostalAddressSame) {
      props.onChange({
        visitingAddress: newVisitingAddress,
        postalAddress: newVisitingAddress
      });
    } else {
      props.onChange({
        visitingAddress: newVisitingAddress,
        postalAddress: props.value.postalAddress
      });
    }
  }

  return <div style={props.noLeftPadding ? { paddingLeft: 0 } : undefined} className="main-section-template-fields-padding">
    <AddressWithNameInnerForm
      address={props.value.visitingAddress}
      onChange={onChange}
      submit={props.submit}
      isSaving={props.isSaving}
    />
  </div>
}